import Base from "./base.service";

export default class StorageItem extends Base {
  constructor() {
    super("storage-items/admin");
  }
}